export default __webpack_public_path__ + "static/media/blue-check.8d3d0d75.svg";